const SPLUNK_BASE_PATH = '/en-US/app/search/mfgdm_db_migration_service';
const SPLUNK_OVERVIEW_BASE_PATH = '/en-US/app/search/mfgdm_db_migration_service_overview';
const SPLUNK_STATIC_PARAMS = 'form.collection_Id=""' +
    '&form.clonedStack=true' +
    '&form.collectionId=*' +
    '&form.ecEventType=SNAPSHOT_UPDATED' +
    '&form.useAurora="useAurora=true"' +
    '&form.snapshotId=""' +
    '&form.dd_fRlATdOr=*' +
    '&form.workflowType=*';
const SPLUNK_OVERVIEW_STATIC_PARAMS = SPLUNK_STATIC_PARAMS + '&form.dd_UBVdOC7q=*&form.dd_ablMRgWU=*';
function getSplunkConfig(environment) {
    if (environment === 'production') {
        return { domain: 'autodesk.splunkcloud.com', envCode: '-p-ue1', g2Tab: 'layout_zdbNLepV' };
    }
    if (environment === 'staging') {
        return {
            domain: 'pp-autodesk.splunkcloud.com',
            envCode: '-s-ue1',
            g2Tab: 'layout_zXHugWPT',
        };
    }
    return { domain: 'pp-autodesk.splunkcloud.com', envCode: '-c-uw2', g2Tab: 'layout_zXHugWPT' };
}
function computeLatest(earliest) {
    const sevenDaysAfterStart = new Date(new Date(earliest).getTime() + 7 * 24 * 60 * 60 * 1000).toISOString();
    return sevenDaysAfterStart < new Date().toISOString() ? sevenDaysAfterStart : 'now';
}
function buildUrl(basePath, staticParams, domain, tab, batchId, envCode, earliest, latest) {
    const dynamicParams = [
        `form.context=${encodeURIComponent(batchId)}`,
        `form.env=${encodeURIComponent(envCode)}`,
        `form.time_range.earliest=${encodeURIComponent(earliest)}`,
        `form.time_range.latest=${encodeURIComponent(latest)}`,
    ].join('&');
    return `https://${domain}${basePath}?tab=${tab}&${staticParams}&${dynamicParams}`;
}
export function buildSplunkStaticDashboardUrl(dashboard, environment) {
    const { domain } = getSplunkConfig(environment);
    const path = dashboard === 'admin'
        ? '/en-US/app/search/mfgdm_db_migration_admin'
        : '/en-US/app/search/mfgdm_db_migration_service';
    return `https://${domain}${path}`;
}
export function buildSplunkJobUrl(contextId, jobType, environment, jobStartTime, runInClonedStack) {
    if (jobType !== 'scheduleMigration' && jobType !== 'scheduleValidation') {
        return null;
    }
    const { domain, envCode, g2Tab } = getSplunkConfig(environment);
    const latest = computeLatest(jobStartTime);
    const tab = jobType === 'scheduleMigration' ? g2Tab : 'layout_validation';
    const effectiveEnvCode = jobType === 'scheduleValidation' && runInClonedStack ? `${envCode}-cs` : envCode;
    return buildUrl(SPLUNK_BASE_PATH, SPLUNK_STATIC_PARAMS, domain, tab, contextId, effectiveEnvCode, jobStartTime, latest);
}
export function buildSplunkDeltaRealValidationJobUrl(contextId, environment, jobStartTime) {
    const { domain, envCode } = getSplunkConfig(environment);
    const latest = computeLatest(jobStartTime);
    return buildUrl(SPLUNK_BASE_PATH, SPLUNK_STATIC_PARAMS, domain, 'layout_zXJDMGYb', contextId, envCode, jobStartTime, latest);
}
export function buildSplunkDashboardUrls(batchId, environment, firstMigrationJobStartTime, firstValidationJobStartTime) {
    const { domain, envCode, g2Tab } = getSplunkConfig(environment);
    const validationEarliest = firstValidationJobStartTime ?? firstMigrationJobStartTime;
    const migrationLatest = computeLatest(firstMigrationJobStartTime);
    return {
        g2: buildUrl(SPLUNK_BASE_PATH, SPLUNK_STATIC_PARAMS, domain, g2Tab, batchId, envCode, firstMigrationJobStartTime, migrationLatest),
        validation: buildUrl(SPLUNK_BASE_PATH, SPLUNK_STATIC_PARAMS, domain, 'layout_validation', batchId, envCode, validationEarliest, computeLatest(validationEarliest)),
        overview: environment === 'production'
            ? buildUrl(SPLUNK_OVERVIEW_BASE_PATH, SPLUNK_OVERVIEW_STATIC_PARAMS, 'autodesk.splunkcloud.com', 'layout_ynM2gdAQ', batchId, '-p-ue1', firstMigrationJobStartTime, migrationLatest)
            : null,
    };
}
